const CampaignBanner = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="147"
      height="102"
      version="1.1"
      viewBox="0 0 147 102"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0 3.23788C0 1.44965 1.44965 0 3.23789 0H143.762C145.55 0 147 1.44965 147 3.23789V98.7621C147 100.55 145.55 102 143.762 102H3.23788C1.44965 102 0 100.55 0 98.7621V3.23788Z"
        fill="#F7F7F7"
      />
      <g transform="translate(.3927 -1.7511)" fill="#d6d6d6">
        <circle cx="11.294" cy="13.133" r="6.479" strokeWidth=".69811" />
        <g transform="translate(-.17511 2.9768)">
          <rect
            x="115.92"
            y="7.1794"
            width="25.653"
            height="5.7785"
            ry="2.8893"
          />
          <rect
            x="94.908"
            y="7.1794"
            width="16.373"
            height="5.7785"
            ry="2.8893"
          />
          <rect
            x="68.817"
            y="7.1794"
            width="21.451"
            height="5.7785"
            ry="2.8893"
          />
        </g>
      </g>
      <g transform="translate(-4.3879 -11.609)" fill="#d6d6d6">
        <g transform="translate(0 .080042)">
          <rect
            x="14.068"
            y="41.124"
            width="60.425"
            height="11.645"
            ry="5.8223"
          />
          <g transform="translate(14.068 7.0563)">
            <rect y="51.652" width="43.864" height="5.0781" ry="2.4077" />
            <rect
              x=".21889"
              y="58.768"
              width="36.335"
              height="5.0781"
              ry="2.5391"
            />
          </g>
          <g transform="translate(14.287 1.1082)">
            <rect y="75.734" width="18.386" height="7.0918" ry="3.5459" />
            <rect
              x="21.277"
              y="75.734"
              width="18.386"
              height="7.0918"
              ry="3.5459"
            />
          </g>
        </g>
        <ellipse cx="115.89" cy="62.609" rx="25.569" ry="25.569" />
      </g>
      <g
        transform="translate(.41277 -4.2141)"
        fill="#d6d6d6"
        strokeWidth=".86427"
      >
        <rect
          x="9.2823"
          y="89.675"
          width="37.181"
          height="28.602"
          ry="2.5391"
        />
        <rect
          x="54.497"
          y="89.675"
          width="37.181"
          height="28.602"
          ry="2.5391"
        />
        <rect
          x="99.711"
          y="89.675"
          width="37.181"
          height="28.602"
          ry="2.5391"
        />
      </g>
    </svg>
  );
};

export default CampaignBanner;
